import React from "react";

function PayPalForm({ userId, fileId }) {
  return (
    <div id="paypal-button-container">
      <form action="https://www.paypal.com/cgi-bin/webscr" method="post">
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input type="hidden" name="hosted_button_id" value="DSYBK445NV6V2" />
        <input type="hidden" name="currency_code" value="EUR" />
        <input
          type="image"
          src="https://www.paypalobjects.com/en_US/i/btn/btn_paynowCC_LG.gif"
          border="0"
          name="submit"
          title="PayPal - The safer, easier way to pay online!"
          alt="Buy Now"
        />
        <input type="hidden" name="custom" value={userId} />
        <input type="hidden" name="custom2" value={fileId} />
      </form>
    </div>
  );
}

export default PayPalForm;
